import { render, staticRenderFns } from "./splitFee.vue?vue&type=template&id=473b6898"
import script from "./splitFee.vue?vue&type=script&lang=js"
export * from "./splitFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports